module.exports = __webpack_public_path__ + "img/cancel_orange.df9d6b3f.svg";